import styled from 'styled-components';
import getThemeByProps from '@userzoomlibraries/toolkit-theme-manager/get-theme-by-props';
import React from 'react';
import { I as InputGeneric } from './index.styled7.js';
import { T as TYPES, b as TEXT_PROP_TYPES, c as TEXT_DEFAULT_PROPS } from './index.styled8.js';
import { jsx } from 'react/jsx-runtime';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var InputText$1 = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/jsx(InputGeneric, _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    type: TYPES.TEXT,
    "aria-placeholder": props.placeholder
  }));
});
InputText$1.COMPONENT_ID = 'Gearz.Input.Text';
InputText$1.displayName = InputText$1.COMPONENT_ID;
InputText$1.propTypes = _objectSpread({}, TEXT_PROP_TYPES);
InputText$1.defaultProps = _objectSpread({}, TEXT_DEFAULT_PROPS);

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var InputText = styled(InputText$1).withConfig({
  componentId: "gz-input-1679042055220__sc-b0bqji-0"
})(["background-color:#fff;border:1px solid #000;border-radius:4px;box-sizing:border-box;display:flex;line-height:20px;margin:0px;min-width:0;position:relative;width:100%;&:not(:focus-within){&:not([aria-disabled=\"true\"]){&[aria-invalid=\"true\"]{border-color:#f00314;&:focus,&:focus-visible,&:hover{border-color:#474b6d;}}}}", ""], function (props) {
  return getThemeByProps({
    componentId: InputText$1.COMPONENT_ID,
    props: props
  });
});
InputText.displayName = InputText$1.displayName;
InputText.propTypes = InputText$1.propTypes;
InputText.defaultProps = InputText$1.defaultProps;

export { InputText as I };
